import {Achat} from '@/models';

export default [
	{
		path: '/achats',
		name: 'achats',
		meta: {
			title: 'Liste des coupes achetés',
			granted: [ 'API_GET_ACHAT' ],
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Achat.vue')
	},
	{
		path: '/achats-encours',
		name: 'achats-encours',
		meta: {
			title: 'Coupes en cours',
			granted: [ 'API_GET_ACHAT' ],
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/AchatEncours.vue')
	},
	{
		path: '/MapAchats',
		name: 'MapAchats',
		meta: {
			title: 'MAP des coupes',
			granted: [ 'API_GET_ACHAT' ],
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/AchatMap.vue')
	},
	{
		path: '/achats/show/:id',
		name: 'achat-show',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Achat/Show.vue'),
				class: Achat
			}),
			editRoute: { name: 'achat-edit' },
		},
		meta: {
			title: 'Détail d\'un achat',
			granted: [ 'API_GET_ACHAT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
	{
		path: '/achats/edit/:id',
		name: 'achat-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Achat/Edit.vue'),
				class: Achat
			}),
		},
		meta: {
			title: 'Edition d\'un achat',
			granted: [ 'API_PUT_ACHAT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];
